<div class="IPO-card mb-2">
    <div class="p-2 IPO-card-header font-small leaf" [style.left]="translate.currentLang=='ar' ? '0':null"
        [style.right]="translate.currentLang=='en' ? '0':null">
        {{lang == 'ar'? iPODetails?.IpoStatusAr : iPODetails?.IpoStatusEn}}
    </div>
    <div class="row mx-1">
        <div class="IPO-card-logo-container d-flex align-item-center">
            <img class="avatar " [src]="iPODetails?.Logo" alt="">
        </div>
        <div class="mx-3 d-flex flex-column align-items-start">
            <h5 class="text-color-theme font-medium font-600">{{lang == 'ar'? iPODetails?.NameAr : iPODetails?.NameEn}}</h5>
            <h6 *ngIf="iPODetails?.SectorEn && lang == 'en'" class="dimmed-Title font-small">{{iPODetails?.SectorEn}}</h6>
            <h6 *ngIf="iPODetails?.SectorAr && lang == 'ar'" class="dimmed-Title font-small">{{iPODetails?.SectorAr}}</h6>
        </div>
    </div>
    <div class="row my-3">
        <div *ngIf="iPODetails?.StockPrice || iPODetails?.MinPrice" class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xm-12  d-flex flex-column align-items-start">
            <div class="text-nowrap dimmed-title-2 font-small">
                <ng-container *ngIf="iPODetails?.PriceType === 0; else rangePrice">
                    {{ "ipoPrice" | translate }}
                </ng-container>
                <ng-template #rangePrice>
                    {{ "range-price" | translate }}
                </ng-template>
                <span>
                    <hint-popover [key]="'ipo-price-hint'" [iconColor]="isDarkTheme ? '#dedede' : 'lightslategray'">
                    </hint-popover>
                </span>
            </div>
            <span class="text-highlight-company-color font-medium font-600">
                {{
                    iPODetails?.PriceType === 0
                        ? (iPODetails?.StockPrice != null
                            ? (iPODetails?.StockPrice | number: '1.2-2' |numberFormat)
                            : (iPODetails?.MinPrice | number: '1.2-2' |numberFormat))
                        : iPODetails?.PriceType === 1
                            ? (iPODetails?.MinPrice | number: '1.2-2'|numberFormat) + ' - ' + (iPODetails?.MaxPrice | number: '1.2-2'|numberFormat)
                            : ''
                }}
                {{ "EGP" | translate }}
            </span>
        </div>
        <div *ngIf="iPODetails?.PublicStake" class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xm-12  d-flex flex-column align-items-start text-nowrap">
            <div class="dimmed-title-2 font-small">
                {{ "publicStake" | translate }}
                <!-- <span>
                    <hint-popover [key]="'gross-sales-hint'"
                        [iconColor]="isDarkTheme?'#dedede':'lightslategray'"></hint-popover>
                </span> -->
            </div>
            <span class="text-highlight-company-color font-medium font-600">{{iPODetails?.PublicStake |numberFormat}}</span>
        </div>
        <div *ngIf="iPODetails?.IssueSize" class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xm-12 d-flex flex-column align-items-start">
            <div class="text-nowrap dimmed-title-2 font-small">
                {{ "issueSize" | translate }}
                <span>
                    <hint-popover [key]="'ipo-issue-size-info'"
                        [iconColor]="isDarkTheme?'#dedede':'lightslategray'"></hint-popover>
                </span>
            </div>
            <span class="text-highlight-company-color font-medium font-600">{{iPODetails?.IssueSize |numberFormat }}</span>
        </div>
    </div>
</div>

<span
    class="d-flex flex-wrap justify-content-center my-3">
    <img src="assets/img/Group.png" alt="">
    <span class="text-color-theme tx-18 font-600"> {{'ipoOrders'|translate}}: {{iPODetails?.OrderTime?.split('-')[0]| timeFormat:'HH:mm'}} - {{iPODetails?.OrderTime?.split('-')[1]| timeFormat:'HH:mm' }}. {{'tradeWisley'|translate}} </span>
</span>

<div class="d-flex flex-xl-row flex-lg-row flex-md-row flex-sm-row flex-column ">
    <div class="col-xl-6 col-md-6 col-lg-6 col-sm-6 col-xs-12 p-1">
        <div *ngIf="iPODetails?.SafeGuardAr || iPODetails?.SafeGuardEn" class="IPO-card mb-2">
            <div class="d-flex">
                <div class="yellow-calender-icon-container calender-icon-container p-2 d-flex">
                    <img src="assets/img/Frame.svg" alt="">
                </div>
                <div class="mx-2 d-flex flex-column align-items-start">
                    <span class="text-nowrap dimmed-title-2 font-small">
                        {{ "safeGuard" | translate }}
                        <span>
                            <hint-popover [key]="'ipo-safe-guard-info'"
                                [iconColor]="isDarkTheme?'#dedede':'lightslategray'"></hint-popover>
                        </span>
                    </span>
                    <span class="text-color-theme font-medium font-600">{{lang == 'ar'? iPODetails?.SafeGuardAr : iPODetails?.SafeGuardEn}}</span>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-6 col-md-6 col-lg-6 col-sm-6 col-xs-12 p-1">
        <div *ngIf="iPODetails?.PeRatio" class="IPO-card mb-2">
            <div class="d-flex">
                <div class="green-calender-icon-container calender-icon-container p-2 d-flex">
                    <img src="assets/img/FramePer.svg" alt="">
                </div>
                <div class="mx-2 d-flex flex-column align-items-start">
                    <span class="text-nowrap   dimmed-title-2 font-small">
                        {{ "PERatio" | translate }}
                        <span>
                            <hint-popover [key]="'ipo-pe-ratio-info'"
                                [iconColor]="isDarkTheme?'#dedede':'lightslategray'"></hint-popover>
                        </span>
                    </span>
                    <span class="text-color-theme font-medium font-600">{{iPODetails?.PeRatio| number: '1.2-2'}}%</span>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="d-flex flex-xl-row flex-lg-row flex-md-row flex-sm-row flex-column ">
    <div class="col-xl-6 col-md-6 col-lg-6 col-sm-6 col-xs-12 p-1">
        <div *ngIf="iPODetails?.CompanyShares" class="IPO-card  mb-2">
            <div class="d-flex">
                <div class="blue-calender-icon-container calender-icon-container p-2 d-flex">
                    <img src="assets/img/FrameAna.svg" alt="">
                </div>
                <div class="mx-2 d-flex flex-column align-items-start">
                    <span class="text-nowrap dimmed-title-2 font-small">
                        {{ "companyShares" | translate }}
                        <span>
                            <hint-popover [key]="'ipo-company-shares-info'"
                                [iconColor]="isDarkTheme?'#dedede':'lightslategray'"></hint-popover>
                        </span>
                    </span>
                    <span class="text-color-theme font-medium font-600">{{iPODetails?.CompanyShares |numberFormat}}</span>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-6 col-md-6 col-lg-6 col-sm-6 col-xs-12 p-1">
        <div *ngIf="iPODetails?.FloatPercentage" class="IPO-card  mb-2">
            <div class="d-flex">
                <div class="red-calender-icon-container calender-icon-container p-2 d-flex">
                    <img src="assets/img/FrameRedPer.svg" alt="">
                </div>
                <div class="mx-2 d-flex flex-column align-items-start">
                    <span class="text-nowrap dimmed-title-2 font-small">
                        {{ "floatPercentage" | translate }}
                        <span>
                            <hint-popover [key]="'ipo-float-perc-info'"
                                [iconColor]="isDarkTheme?'#dedede':'lightslategray'"></hint-popover>
                        </span>
                    </span>
                    <span class="text-color-theme font-medium font-600">{{iPODetails?.FloatPercentage| number: '1.2-2'}}%</span>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="alert-div alert-div-warning d-flex flex-wrap mt-2" *ngIf="coverageRatio !== null || coverageRatio !== 0 ">
    <div class="mx-2 d-flex flex-column align-items-start">
        <div class="d-flex ">
            <div class="icon-w">
                <img src="assets/img/ring.svg" alt="">
            </div>
            <span class="yellow-text mx-1 font-600 w-100">
                {{'ipoStartAlert'| translate}}
            </span>
        </div>
        <span class="alert-desc-color  font-small mx-4 text-start" *ngIf="coverageRatio > 1" >
            {{'ipoStartAlertDesc'|translate}} 
            <br>
            {{'numberOfcoverage'|translate}}: <span class="font-600" *ngIf="!isRefreshing">{{coverageRatio | number : '1.2-2'}}</span>
        </span>
        <span class="alert-desc-color  font-small mx-4 text-start" *ngIf="coverageRatio <= 1" >
            {{'ipoStartAlertDesc'|translate}} 
            <br>
            {{'numberOfcoverageLessthanOne'|translate}}
        </span>
    </div>
</div>


<!-- <div  class="d-flex flex-column"> -->
    <div class="IPO-card mt-4 ">
        <div class="d-flex flex-column align-items-start  text-color-theme font-medium font-600">{{'information'|translate}}</div>
        <ng-container *ngIf="ipoDocuments?.InformationAr && ipoDocuments?.InformationEn ">
            <div class="d-flex flex-column align-items-start " *ngIf="ipoDocuments?.InformationAr || ipoDocuments?.InformationEn ">
                <div class="my-3 dimmed-title-2 font-small text-start">
                    {{lang == 'ar'? ipoDocuments?.InformationAr : ipoDocuments?.InformationEn  }}
                </div>
            </div>
        </ng-container>
        
        <div  *ngIf="!ipoDocuments?.InformationAr && !ipoDocuments?.InformationEn " class="text-center nodata  d-flex flex-column align-items-center justify-content-center">
            <img class="img-not-found-width" src="assets/img/no-data-vector.png" />
            <div class="no-data-available mt-2 font-600" > {{'no-data-available'|translate}} </div>
        </div>
        <div class="d-flex flex-column align-items-start ">
            <button class="my-3 green-outline-btn rounded-btn" [ngClass]="{'disabled': !DisabledEtrade}" (click)="fundActionModal()">{{'applyNow'|translate}}</button>
        </div>
    </div>
<!-- </div> -->